<h1 mat-dialog-title>Gestione opzioni</h1>

<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <div class="form-wrapper mt-1">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options">
      </formly-form>
    </form>
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="mt-5">
  <div class="row w-100">
    <div class="col-6 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default color="warn">
        {{ 'common.cta.close' | translate }}
      </a>
    </div> <!-- /.col -->
    <div class="col-6 text-right">
      <a mat-button (click)="onFormSubmit()" mat-raised-button mat-default color="warn">
        {{ 'common.cta.save' | translate }}
      </a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>
